import { engineComponent } from "neo-common";
import { ComponentTypes } from "./ComponentTypes";

/**
 * Configuration hold elements configurations from xml by ID.
 * @class Configuration
 */
@engineComponent(ComponentTypes.Element)
export class Configuration {
    static Configurations: { [id: string]: Element } = {};
}

export const GeneralConfigurationAttributes = {};

export const RouletteWheelConfigurationAttributes = {
    WHEEL_STRIP: "WheelStrip",
    MIN_SPIN_ROTATION: "MinSpinRotation",
    MIN_SPIN_ROTATION_LONG: "MinSpinRotationLong",
};

export const RouletteGridConfigurationAttributes = {
    GRID_WIDTH: "GridWidth",
    GRID_HEIGHT: "GridHeight",
    ZERO_WIDTH: "ZeroWidth",
    COLUMN_WIDTH: "ColumnWidth",
    DOZEN_HEIGHT: "DozenHeight",
    PAIRED_HEIGHT: "PairedHeight",
};

export const RouletteGridEdgeBetsConfigurationAttributes = {
    /**
     * Width of grid edge bet selector in px.
     */
    WIDTH: "Width",

    /**
     * Height of grid edge bet selector in px.
     */
    HEIGHT: "Height",

    /**
     * Define offset Y of next chip placed on bet place, where chip is already placed.
     */
    CHIP_OFFSET_Y: "ChipOffsetY",
};

export const RouletteRacetrackBetsConfigurationAttributes = {
    WIDTH: "Width",
    HEIGHT: "Height",
    SINGLE_WIDTH: "SingleWidth",
    SINGLE_HEIGHT: "SingleHeight",
    TIERS_WIDTH: "TiersWidth",
    ORPHELINS_WIDTH: "OrphelinsWidth",
    VOISINS_WIDTH: "VoisinsWidth",
    ZERO_GAME_WIDTH: "ZeroGameWidth",
    MIDDLE_HEIGHT: "MiddleHeight",
    TIERS: "Tiers",
    ORPHELINS: "Orphelins",
    VOISINS: "Voisins",
    ZERO_GAME: "ZeroGame",
    NEIGHBOURS: "Neighbours",
    NEIGHBOURS_DEFALUT: "NeighboursDefault",
};

export const RouletteBetConfigurationAttributes = {
    SINGLE: "Single",
    SPLIT_VERTICAL: "SplitVertical",
    SPLIT_HORIZONTAL: "SplitHorizontal",
    STREET: "Street",
    CORNER: "Corner",
    DOUBLE_STREET: "DoubleStreet",
    TRIO: "Trio",
    FIRST_FOUR: "FirstFour",
    BASKET: "Basket",
    LOW_OR_HIGH: "LowOrHigh",
    RED_OR_BLACK: "RedOrBlack",
    EVEN_OR_ODD: "EvenOrOdd",
    DOZEN: "Dozen",
    COLUMN: "Column",
};

export const RouletteSingleBetLimitConfigurationAttributes = {
    SINGLE: "Single",
    SPLIT_VERTICAL: "SplitVertical",
    SPLIT_HORIZONTAL: "SplitHorizontal",
    STREET: "Street",
    CORNER: "Corner",
    DOUBLE_STREET: "DoubleStreet",
    TRIO: "Trio",
    FIRST_FOUR: "FirstFour",
    BASKET: "Basket",
    LOW_OR_HIGH: "LowOrHigh",
    RED_OR_BLACK: "RedOrBlack",
    EVEN_OR_ODD: "EvenOrOdd",
    DOZEN: "Dozen",
    COLUMN: "Column",
};

export const RouletteSingleBetMultiplierConfigurationAttributes = {
    SINGLE: "Single",
    SPLIT_VERTICAL: "SplitVertical",
    SPLIT_HORIZONTAL: "SplitHorizontal",
    STREET: "Street",
    CORNER: "Corner",
    DOUBLE_STREET: "DoubleStreet",
    TRIO: "Trio",
    FIRST_FOUR: "FirstFour",
    BASKET: "Basket",
    LOW_OR_HIGH: "LowOrHigh",
    RED_OR_BLACK: "RedOrBlack",
    EVEN_OR_ODD: "EvenOrOdd",
    DOZEN: "Dozen",
    COLUMN: "Column",
};

export const ChipColorsConfigurationAttributes = {
    COLORS: "Colors",
    WIDTH: "Width",
    HEIGHT: "Height",
};

export const HistoryConfigurationAttributes = {
    COUNT: "Count",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Configuration.ts
 **/